import { FileRejectionReason, FileAccStatus } from '@/generated/graphql.ts';

export enum FileAccountingStatus {
  Processing = 'Processing',
  Confirmed = 'Confirmed',
  Denied = 'Denied',
}

export interface IFileAccountingStatusOption {
  id: FileAccStatus;
  title: string;
}

export const FILE_ACCOUNTING_STATUS_OPTIONS: IFileAccountingStatusOption[] = [
  {
    id: FileAccStatus.Processing,
    title: FileAccountingStatus.Processing,
  },
  {
    id: FileAccStatus.Confirmed,
    title: FileAccountingStatus.Confirmed,
  },
  {
    id: FileAccStatus.Denied,
    title: FileAccountingStatus.Denied,
  },
];

export const getAccountingStatusColorClass = (statusId: FileAccStatus | null | undefined) => {
  if (!statusId) return;
  switch (statusId) {
    case FileAccStatus.Processing:
      return 'text-blue';
    case FileAccStatus.Confirmed:
      return 'text-teal';
    case FileAccStatus.Denied:
      return 'text-red';
    default:
      return 'text-blue';
  }
};

export const getAccountingStatusText = (statusId: FileAccStatus | null | undefined): string => {
  if (statusId === null || statusId === undefined) return '';
  const status = FILE_ACCOUNTING_STATUS_OPTIONS.find(option => option.id === statusId);
  return status?.title || FileAccountingStatus.Processing;
};

export const getRejectionReasonText = (reasonId: FileRejectionReason | null | undefined): string => {
  if (!reasonId) return '';
  const reason = DENIAL_OPTIONS.find(option => option.id === reasonId);
  return reason?.title || '';
};

export enum DenialReason {
  MissingDetails = 'Missing details',
  UnrelatedToAccounting = 'Unrelated to Accounting',
  Other = 'Other'
}

export enum DenialReasonId {
  MissingDetails = 1,
  UnrelatedToAccounting = 2,
  Other = 3
}

export interface IDenialOption {
  id: FileRejectionReason;
  title: DenialReason;
  value: DenialReasonId;
}

export interface DeniableFileType {
  id: string;
  accStatusId: FileAccStatus;
  rejectionReasonId?: FileRejectionReason | null;
  rejectionComment?: string | null;
}

export const DENIAL_OPTIONS: IDenialOption[] = [
  {
    id: FileRejectionReason.MissingDetails,
    title: DenialReason.MissingDetails,
    value: DenialReasonId.MissingDetails,
  },
  {
    id: FileRejectionReason.UnrelatedToAccounting,
    title: DenialReason.UnrelatedToAccounting,
    value: DenialReasonId.UnrelatedToAccounting,
  },
  {
    id: FileRejectionReason.Other,
    title: DenialReason.Other,
    value: DenialReasonId.Other,
  },
];

export interface IAccountingFileStatusUpdate {
  fileId: string;
  accStatusId: FileAccStatus;
  rejectionReasonId: FileRejectionReason | null;
  rejectionComment: string | null;
}
